import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { HttpHeaderNames } from "@touchtech/web-api-client";

import { LocalStorageKeys } from "@is/constants";
import { useStoreLanguage } from "@is/hooks/useStoreLanguage";
import { LocalStorageService, api } from "@is/services";

export const useSetStoreLanguage = () => {
  const { i18n } = useTranslation();
  const tenantId = LocalStorageService.getItem(LocalStorageKeys.TenantId);

  api.setHeader(HttpHeaderNames.TENANT_ID, tenantId);

  const { storeLanguageCode } = useStoreLanguage();

  const setStoreLanguage = useCallback(() => {
    i18n.changeLanguage(storeLanguageCode);
    LocalStorageService.setItem(
      LocalStorageKeys.LanguageCode,
      storeLanguageCode
    );
  }, [i18n, storeLanguageCode]);

  return { setStoreLanguage };
};
